import { ApiResponse, PaginatedApiResponse } from '../shared.types';

import { GolfCourse, CreateGolfCourseData } from './golfCourse.types';

import axiosServer from '@/services/axios';
import { transformToApiError } from '@/utils/error.ts';

const endpoint = '/golfCourse';

export const getGolfCourseById = async (
  id: string
): Promise<ApiResponse<{ golfCourse: GolfCourse }>> => {
  try {
    const response = await axiosServer.get(`${endpoint}/${id}`);
    return response.data;
  } catch (error) {
    return transformToApiError(error);
  }
};

export const createGolfCourse = async (
  data: CreateGolfCourseData
): Promise<ApiResponse<{ golfCourse: GolfCourse }>> => {
  try {
    const response = await axiosServer.post(endpoint, data);
    return response.data;
  } catch (error) {
    return transformToApiError(error);
  }
};

export const getAllGolfCourses = async (): Promise<
  ApiResponse<{ golfCourses: GolfCourse[] }>
> => {
  try {
    const response = await axiosServer.get(endpoint);
    return response.data;
  } catch (error) {
    return transformToApiError(error);
  }
};

export const getAllGolfCoursesPaginated = async (
  page: number,
  pageSize: number
): Promise<PaginatedApiResponse<GolfCourse>> => {
  try {
    const params = { page, pageSize };
    const response = await axiosServer.get(`${endpoint}/paginated`, { params });
    return response.data;
  } catch (error) {
    return transformToApiError(error);
  }
};

export const updateGolfCourse = async (
  id: string,
  data: CreateGolfCourseData
): Promise<ApiResponse<{ golfCourse: GolfCourse }>> => {
  try {
    const response = await axiosServer.put(`${endpoint}/${id}`, data);
    return response.data;
  } catch (error) {
    return transformToApiError(error);
  }
};

export const deleteGolfCourse = async (
  id: string
): Promise<ApiResponse<{ golfCourse: GolfCourse }>> => {
  try {
    const response = await axiosServer.delete(`${endpoint}/${id}`);
    return response.data;
  } catch (error) {
    return transformToApiError(error);
  }
};
